<p-accordion [value]="selected ? 'general-fields' : null">
  <p-accordion-panel value="general-fields">
    <p-accordion-header>General Fields</p-accordion-header>
    <p-accordion-content>
      <div class="general-fields">
        <form class="content" (ngSubmit)="onSubmit()" [formGroup]="form"
          (keydown)="keepCaretKeys($event)">
          <div class="form-row" *ngFor="let formField of formFields">
            <form-field [formField]="formField" [form]="form"></form-field>
          </div>
        </form>
      </div>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>
